import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    throwError as observableThrowError,
    Observable,
    BehaviorSubject,
    throwError,
} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Response } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class ExploreService {

  constructor(
    private http: HttpClient,
    @Inject('baseUrl') private baseUrl: string
) {}

//fetch all user portfolio by productType
    news() {
        return this.http
            .get(this.baseUrl + `/news?pageSize=12&productType=ADVISORY`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    learn() {
      return this.http
      .get(this.baseUrl + `/learn?pageSize=2&pageNumber=0&productType=ADVISORY`)
      .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

}